import React from 'react';
import { addElement, setOnPremiseState } from '../../../actions/CreateSiteActions/createSiteActions'
import { connect } from 'react-redux';
import Levels from "./ConfidentialityLevels";
import InfoTooltip from '../../formFields/InfoTooltip';

import ExternalCollaboration from "./ExternalCollaboration";
import Warning from "../CommonComponents/Warning";
import MessageForBlockedUsers from "../CommonComponents/MessageForBlockedUsers";
import { AdditionalPermissionRole } from '../../../GlobalConst/globalEnums';



class ConfidentialityLevel extends React.Component {
    
    render() {
        const toolTipContent = 
            <span>For more information about where you can store which information read the <a href='https://search.abb.com/library/Download.aspx?DocumentID=9AAD141652&LanguageCode=en&DocumentPartId=&Action=Launch' target="_blank" rel="noopener noreferrer">Store & Share guidelines</a></span>;

        const warning = this.props.possibleWarning && !this.props.confidentiality ? <Warning element=""/> : null;
        
        const levels = <Levels level={this.props.confidentialLevel} blockedGroupEmployee={this.props.currentUser.additionalPermissionRoles.includes(AdditionalPermissionRole.blockedGroupEmployee)} />
        return (
            <div className="wizard-inside">
                <div className="item-title">
                    Select sensitivity label of your site
                    <InfoTooltip content={toolTipContent} />
                    {warning}
                </div>
                <div style={{fontWeight:'bold', fontSize:'12px', height: '25px'}}>
                    To learn more about site privacy and sensitivity labels click <a href='https://go.insideplus.abb.com/information-systems/gf-is/scenarios/store-and-share-digital-information/information-classification-and-labelling' target="_blank" rel="noopener noreferrer">here</a>.
                </div>
                {levels}
                <MessageForBlockedUsers blockedGroupEmployee={this.props.currentUser.additionalPermissionRoles.includes(AdditionalPermissionRole.blockedGroupEmployee)} />
                <ExternalCollaboration/>
            </div>
            
        );
    }
}
const mapActionsToProps = {
    sendElement: addElement,
    setOnpremise: setOnPremiseState,
  //  updateValidationStatus: updateValidationStatus
}
const mapStateToProps = state => ({
    confidentiality: state.newSite.Confidentiality,
    possibleWarning: state.wizard.nextStepRequested,
    currentUser: state.user.currentUser,
    isIATU : state.newSite.isIATU,
    isIAPCP :  state.newSite.isIAPCP
  //  validationResult: state.step1Validation.ConfidentialityValid
})

export default connect(mapStateToProps, mapActionsToProps)(ConfidentialityLevel);





// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/Confidentiality.js